// QRScanner.jsx
import React, { useEffect } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";

const QRScanner = ({ onScan }) => {
    useEffect(() => {
        const scanner = new Html5QrcodeScanner("qr-reader", {
            fps: 10,
            qrbox: { width: 250, height: 250 },
        });

        scanner.render(
            (decodedText) => {
                scanner.clear();
                onScan(decodedText);
            },
            (error) => {
                // Ошибки при сканировании
                console.warn("QR Scan Error:", error);
            }
        );

        return () => {
            scanner.clear().catch((error) => console.error("Clear error:", error));
        };
    }, [onScan]);

    return <div id="qr-reader" style={{ width: "100%" }} />;
};

export default QRScanner;
